let currentTransform = 'none'; // Persistir el estado global
let animationTimeout = null; // Variable global para controlar el timeout
$(document).on('turbolinks:load', function () {
    const bodyController = $('body').data('controller');
    const mapContainer = document.getElementById("monitoring-map");
    let satelliteType = 'PAR';

    if (mapContainer && bodyController === 'monitoring') {
        let map, activeLayer, radarImageOverlay;

        // Inicializar mapa
        function initializeMap(radarBounds) {
            if (map) {
                map.remove(); // Destruye el mapa existente
                map = null;
            }

            if (radarBounds) {
                map = L.map('monitoring-map').fitBounds(radarBounds);
            } else {
                map = L.map('monitoring-map').setView([-25.2637, -57.5759], 6);
            }

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 18,
                attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
            }).addTo(map);
        }

        // Limpiar capa activa
        function clearActiveLayer() {
            if (activeLayer) {
                activeLayer.clearLayers();
                activeLayer = null;
            }
            if (radarImageOverlay) {
                map.removeLayer(radarImageOverlay);
                radarImageOverlay = null;
            }
        }

        // Actualizar marcadores
        async function updateMarkers(strikes, title, lastFormattedDate) {
            clearActiveLayer();

            // Agrupador de marcadores para manejar grandes cantidades
            markersCluster = L.markerClusterGroup({
                maxClusterRadius: 150, // Agrupa solo marcadores cercanos
                disableClusteringAtZoom: 8, // Desactiva agrupamiento en zoom alto
            }).addTo(map);

            // Icono img para rayos
            const lightningIcon = L.icon({
                iconUrl: '/img/strike.png', // Ruta a tu imagen
                iconSize: [30, 30],
                iconAnchor: [10, 10],
            });

            // Añadir marcadores, agrupando solo si hay muchos fuera de la vista
            strikes.forEach((strike) => {
                const marker = L.marker([strike.lat, strike.lng], { icon: lightningIcon });

                // Solo añadir al mapa si está en el cuadro visible
                if (map.getBounds().contains(marker.getLatLng())) {
                    markersCluster.addLayer(marker);
                }
            });

            activeLayer = markersCluster;

            // Actualizar título y hora
            $('#monitoring-title').html(title);
            if (lastFormattedDate) $('#updated-time').html(lastFormattedDate);

            // Listener para actualizar marcadores visibles al mover el mapa
            map.on('moveend', () => {
                updateVisibleMarkers(strikes, markersCluster, lightningIcon);
            });
        }

        // Actualizar marcadores visibles al mover el mapa
        function updateVisibleMarkers(strikes, markersCluster, lightningIcon) {
            const bounds = map.getBounds();
            markersCluster.clearLayers();

            strikes.forEach((strike) => {
                const marker = L.marker([strike.lat, strike.lng], { icon: lightningIcon });
                if (bounds.contains(marker.getLatLng())) {
                    markersCluster.addLayer(marker);
                }
            });
        }

        // Función común para actualizar el estado del icono de carga
        function toggleLoadingIcon(isLoading) {
            const icon = $('#animate-icon');
            icon.toggleClass('bi-play-fill', !isLoading);
            icon.toggleClass('spinner-grow', isLoading);
        }

        // Cargar rayos iniciales
        async function loadInitialStrikes() {
            toggleLoadingIcon(true);
            initializeMap();
            clearActiveLayer();

            try {
                const response = await fetch(`/strikes/fetch_by_time?time=${getIntervalValue()}`);
                if (!response.ok) throw new Error('Error al obtener los datos iniciales.');
                const { strikes, last_formattedDate, title } = await response.json();
                updateMarkers(strikes, title, last_formattedDate);
            } catch (error) {
                console.error(error);
            } finally {
                toggleLoadingIcon(false);
            }
        }

        // Animar rayos
        async function animateStrikes() {
            toggleLoadingIcon(true);
            const intervals = reorderIntervals();

            for (const time of intervals) {
                try {
                    const response = await fetch(`/strikes/fetch_by_time?time=${time}`);
                    if (!response.ok) throw new Error(`Error al obtener los datos de ${time} minutos.`);
                    const { strikes, last_formattedDate, title } = await response.json();
                    updateMarkers(strikes, title, last_formattedDate);
                    await new Promise((resolve) => setTimeout(resolve, 300));
                } catch (error) {
                    console.error(error);
                }
            }

            toggleLoadingIcon(false);
        }

        // Mostrar radar meteorológico
        async function radarImage() {
            $('#monitoring-title').html('RADAR METEOROLÓGICO');
            clearActiveLayer();

            try {
                const response = await $.ajax({ url: '/radar_refresh', method: 'GET' });
                if (response) {
                    showWindyRadar(false);
                    initializeMap(response.radar_bounds);
                    radarImageOverlay = L.imageOverlay(response.radar_path, response.radar_bounds, { opacity: 0.8 });
                    radarImageOverlay.addTo(map);

                    L.circle([response.lat_center, response.lon_center], {
                        color: '#d3d3d3',
                        fillColor: '#d3d3d3',
                        fillOpacity: 0.2,
                        radius: response.radar_radius * 1000,
                    }).addTo(map);

                    $('#updated-time').html(response.updated_time);
                } else {
                    showWindyRadar(true);
                }
            } catch (error) {
                showWindyRadar(true);
            }
        }

        // Animar el radar
        async function animateRadar() {
            toggleLoadingIcon(true);
            clearActiveLayer();

            try {
                const response = await $.ajax({ url: '/radar_refresh?anima=15', method: 'GET' });
                if (response && response.length > 0) {
                    let index = 0;

                    function showNextImage() {
                        const radarData = response[index];
                        if (radarImageOverlay) {
                            map.removeLayer(radarImageOverlay);
                        }

                        radarImageOverlay = L.imageOverlay(radarData.radar_path, radarData.radar_bounds, { opacity: 0.8 });
                        radarImageOverlay.addTo(map);

                        $('#updated-time').html(radarData.updated_time);
                        index++;
                        if (index < response.length) {
                            setTimeout(showNextImage, 500);
                        } else {
                            toggleLoadingIcon(false);
                        }
                    }

                    showNextImage();
                } else {
                    console.error('No hay datos para la animación.');
                    toggleLoadingIcon(false);
                }
            } catch (error) {
                console.error(error);
                toggleLoadingIcon(false);
            }
        }

        // Limpiar mapa y reutilizar el contenedor para satélite
        function clearMap() {
            if (map) {
                map.remove(); // Eliminar el mapa de Leaflet
                map = null;
            }
            $('#monitoring-map').empty(); // Limpiar el contenedor
        }

        function initializePanzoom(imageElement) {
            const panzoom = Panzoom(imageElement, {
                maxScale: 6,  // Máximo zoom permitido
                minScale: 1,  // Evitar que se reduzca por debajo del tamaño original
                contain: 'outside',
                startScale: 1,
            });

            const zoomContainer = imageElement.parentElement;
            zoomContainer.addEventListener('wheel', panzoom.zoomWithWheel);

            // Flag para evitar ciclos infinitos
            let isAdjustingScale = false;

            imageElement.addEventListener('panzoomchange', (event) => {
                if (isAdjustingScale) return; // Salir si estamos ajustando

                // Validar el transform para evitar valores menores a la escala mínima
                const scaleMatch = event.target.style.transform.match(/scale\(([^)]+)\)/);
                if (scaleMatch) {
                    const scale = parseFloat(scaleMatch[1]);
                    if (scale < 1) {
                        isAdjustingScale = true; // Activar la bandera
                        panzoom.reset(); // Restablecer el zoom al tamaño inicial
                        isAdjustingScale = false; // Desactivar la bandera
                    }
                }
            });

            return panzoom;
        }

        // Función para actualizar la imagen del satélite
        function updateSatelliteImage(imageUrl, containerId, allowPanzoom = true) {
            const $mapDiv = $(containerId);
            $mapDiv.html(`
                <div id="zoom-container" style="width: 100%; height: 100%; overflow: hidden; position: relative;">
                    <img id="satellite-image" 
                         src="${imageUrl}" 
                         alt="Imagen de satélite" 
                         style="width: 100%; height: 100%; display: block; transform-origin: center; transform: ${currentTransform};">
                </div>
            `);

            const imageElement = document.getElementById('satellite-image');
            if (allowPanzoom) {
                initializePanzoom(imageElement);
            }
        }

        // Función para cargar imágenes de satélite
        async function satelliteImages() {
            toggleLoadingIcon(true);
            $('#monitoring-title').html('SATÉLITE METEOROLÓGICO');
            clearMap();

            try {
                const response = await fetch('/satellite.json?satellite_type=' + satelliteType);
                if (!response.ok) throw new Error('Error al obtener las imágenes de satélite.');
                const data = await response.json();

                if (data.images?.length > 0) {
                    const latestImageUrl = data.images[0];
                    updateSatelliteImage(latestImageUrl, '#monitoring-map');

                    const match = latestImageUrl.match(/\d{11}/);
                    if (match) {
                        const formattedTime = formatSatelliteTime(match[0]);
                        $('#updated-time').html(formattedTime);
                    } else {
                        $('#updated-time').html('Hora de actualización no disponible.');
                    }
                } else {
                    $('#monitoring-map').html('<p>No hay imágenes de satélite disponibles.</p>');
                }
            } catch (error) {
                console.error(error);
                $('#monitoring-map').html('<p>Error al cargar imágenes de satélite.</p>');
            }
            toggleLoadingIcon(false);
        }

        // Función para animar imágenes de satélite
        async function animateSatellite() {
            toggleLoadingIcon(true); // Mostrar icono de carga

            try {
                const response = await fetch('/satellite.json?animate=yes&satellite_type=' + satelliteType);
                if (!response.ok) throw new Error('Error al obtener las imágenes de satélite.');
                const data = await response.json();

                if (data.images?.length > 0) {
                    const $mapDiv = $('#monitoring-map');
                    $mapDiv.html('<div id="zoom-container" style="width: 100%; height: 100%; overflow: hidden; position: relative;"></div>');

                    const zoomContainer = document.getElementById('zoom-container');
                    const imageElement = document.createElement('img');
                    imageElement.id = 'satellite-image';
                    imageElement.style = `
                        width: 100%; 
                        height: 100%; 
                        display: block; 
                        transform-origin: center; 
                        transform: ${currentTransform};
                    `;
                    zoomContainer.appendChild(imageElement);

                    const panzoom = initializePanzoom(imageElement);
                    let index = data.images.length - 1;

                    async function showNextImage() {
                        if (index < 0) {
                            clearTimeout(animationTimeout);
                            toggleLoadingIcon(false);
                            return;
                        }
                        toggleLoadingIcon(true);
                        const imageUrl = data.images[index];
                        imageElement.src = imageUrl;

                        await new Promise((resolve) => {
                            imageElement.onload = () => {
                                // Mantén el transform inicial al cargar la primera imagen
                                if (index === data.images.length - 1) {
                                    imageElement.style.transform = currentTransform;
                                }

                                const match = imageUrl.match(/\d{11}/);
                                if (match) {
                                    const formattedTime = formatSatelliteTime(match[0]);
                                    $('#updated-time').html(formattedTime);
                                } else {
                                    $('#updated-time').html('Hora de actualización no disponible.');
                                }
                                resolve();
                            };
                            imageElement.onerror = () => {
                                console.error(`Error al cargar la imagen: ${imageUrl}`);
                                resolve();
                            };
                        });

                        currentTransform = imageElement.style.transform || 'none';
                        index -= 1;
                        animationTimeout = setTimeout(showNextImage, 500); // Tiempo entre imágenes
                    }

                    showNextImage();
                } else {
                    $('#monitoring-map').html('<p>No hay imágenes para animación.</p>');
                }
            } catch (error) {
                console.error(error);
                $('#monitoring-map').html('<p>Error al cargar animación de imágenes.</p>');
            }
            toggleLoadingIcon(false);
        }

        // Obtener el tipo de monitoreo activo
        function getActiveMonitoringType() {
            const activeButton = $('.btn-group-monitoring .monitoring-btn.active');
            return activeButton.length ? activeButton.data('type') : 'radar';
        }

        // Sincronizar rayos o radar
        $('#refresh-button').on('click', function () {
            const activeType = getActiveMonitoringType();
            if (activeType === 'radar') {
                radarImage();
                $('#mer-py-button').hide();
            } else if (activeType === 'strikes') {
                showWindyRadar(false);
                $('#mer-py-button').hide();
                loadInitialStrikes();
            } else if (activeType === 'satellite') {
                $('#monitoring-map').html('');
                $('#mer-py-button').show();
                showWindyRadar(false);
                satelliteImages();
            }
        });

        $('#mer-py-button').on('click', function () {
            satelliteType = satelliteType === 'MER' ? 'PAR' : 'MER';
            satelliteImages();
        });

        // Iniciar animación
        $('#animate-button').on('click', function () {
            const activeType = getActiveMonitoringType();
            if (activeType === 'radar') {
                animateRadar();
            } else if (activeType === 'strikes') {
                animateStrikes();
            } else if (activeType === 'satellite') {
                animateSatellite();
            }
        });

        // Cambio de tipo de monitoreo
        $('.monitoring-btn').on('click', function () {
            $('.monitoring-btn').removeClass('active');
            $(this).addClass('active');

            const activeType = $(this).data('type') || 'radar';
            const currentUrl = new URL(window.location);
            currentUrl.searchParams.set('type', activeType);
            window.history.pushState({}, '', currentUrl);

            if (activeType === 'strikes') {
                $('#monitoring-map').html('');
                showWindyRadar(false);
                $('#mer-py-button').hide();
                loadInitialStrikes();
            } else if (activeType === 'radar') {
                $('#monitoring-map').html('');
                $('#mer-py-button').hide();
                radarImage();
            } else if (activeType === 'satellite') {
                $('#monitoring-map').html('');
                $('#mer-py-button').show();
                showWindyRadar(false);
                satelliteImages();
            }
        });

        function showWindyRadar(show) {
            if (show) {
                // Ocultar el radar REDEMET y mostrar el radar WINDY
                $('#monitoring-map').hide();
                $('#windy-radar').show();
                $('#refresh-button').hide();
                $('#animate-button').hide();
                $('#windy-radar-embed').html('<iframe width="100%" height="450px" src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=default&metricTemp=default&metricWind=default&zoom=8&overlay=radar&product=radar&level=surface&lat=-26.907&lon=-55.756" frameborder="0"></iframe>');
            } else {
                // MOstrar el radar REDEMET y ocultar el radar WINDY
                $('#monitoring-map').show();
                $('#windy-radar').hide();
                $('#refresh-button').show();
                $('#animate-button').show();
            }
        }

        // Inicializar en base al parámetro de la URL
        const urlParams = new URLSearchParams(window.location.search);
        const activeType = urlParams.get('type') || 'radar';
        if (activeType === 'strikes') {
            $('#monitoring-map').html('');
            $('#mer-py-button').hide();
            showWindyRadar(false);
            loadInitialStrikes();
        } else if (activeType === 'radar') {
            $('#monitoring-map').html('');
            $('#mer-py-button').hide();
            radarImage();
        } else if (activeType === 'satellite') {
            $('#monitoring-map').html('');
            $('#mer-py-button').show();
            showWindyRadar(false);
            satelliteImages();
        }
    }
});

$(document).on('turbolinks:before-cache', function () {
    if (map) {
        map.remove();
        map = null;
    }
});

// Detener la animación al navegar o recargar la página
$(document).on('turbolinks:before-render', function () {
    clearTimeout(animationTimeout); // Detén cualquier animación activa
});

const intervals = [0, 10, 20, 30, 40, 50];
function reorderIntervals() {
    // Obtén el minuto actual
    const currentMinute = new Date().getMinutes();

    // Encuentra el índice del intervalo que contiene el minuto actual
    const startIndex = intervals.findIndex(
        (interval, index) => currentMinute >= interval && (index === intervals.length - 1 || currentMinute < intervals[index + 1])
    );

    // Reordenar el array para comenzar con el intervalo actual
    return [...intervals.slice(startIndex), ...intervals.slice(0, startIndex)];
}

function getIntervalValue() {
    // Obtener el minuto actual
    const currentMinute = new Date().getMinutes();
    // Encuentra el índice del intervalo actual
    const currentIndex = intervals.findIndex((interval, i) =>
        currentMinute >= interval && currentMinute < (intervals[i + 1] || 60)
    );

    // Obtener el valor del arreglo correspondiente menos 10
    const value = intervals[(currentIndex - 1 + intervals.length) % intervals.length];
    return value;
}

// Función para formatear la hora del satélite
function formatSatelliteTime(customTime) {
    // Desglose del formato personalizado: YYYYMMDDHHmm
    const year = parseInt(customTime.substring(0, 4), 10); // Año (2025)
    const monthIndex = parseInt(customTime.substring(4, 5), 10); // Mes (0 = Enero)
    const day = parseInt(customTime.substring(5, 7), 10); // Día
    const hour = parseInt(customTime.substring(7, 9), 10); // Hora
    const minute = parseInt(customTime.substring(9, 11), 10); // Minutos

    // Crear un objeto Date en UTC
    const utcDate = new Date(Date.UTC(year, monthIndex, day, hour, minute));

    // Convertir a hora local de Asunción (GMT-4 o GMT-3 según horario de verano)
    const options = {
        timeZone: 'America/Asuncion',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    };
    const asuncionTime = new Intl.DateTimeFormat('es-PY', options).format(utcDate);

    // Retornar la hora en formato dd/mm/yyyy hh:mm
    return asuncionTime.replace(',', ''); // Quitar coma que algunos formatos locales incluyen
}

// Función para formatear la hora del satélite
function formatSatelliteTimeDMH(customTime) {

    const anio = parseInt(customTime.substring(0, 4));
    const mes = parseInt(customTime.substring(4, 6)) - 1; // Meses en JavaScript son 0-11
    const dia = parseInt(customTime.substring(6, 8));
    const hora = parseInt(customTime.substring(8, 10));
    const minuto = parseInt(customTime.substring(10, 12));

    let utcDate = new Date(Date.UTC(anio, mes, dia, hora, minuto));

    // Convertir a hora local de Asunción (GMT-4 o GMT-3 según horario de verano)
    const options = {
        timeZone: 'America/Asuncion',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    };
    const asuncionTime = new Intl.DateTimeFormat('es-PY', options).format(utcDate);

    // Retornar la hora en formato dd/mm/yyyy hh:mm
    return asuncionTime.replace(',', ''); // Quitar coma que algunos formatos locales incluyen
}

